import React from "react";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";

interface HeaderProps {
    isMobile: boolean;
}

const Header: React.FC<HeaderProps> = ({ isMobile }) => {
    return isMobile ? <MobileHeader /> : <DesktopHeader />;
};

export default Header;
